import React, { useEffect, useState } from "react";
import "../styles/Reports.css";

import { getDashboardReport } from "../services/adminApi";

import ReportHeader from "../components/reports/ReportHeader";
import ReportFilterBar from "../components/reports/ReportFilterBar";
import SummaryCards from "../components/reports/SummaryCards";

import RevenueChart from "../components/reports/RevenueChart";
import OrdersChart from "../components/reports/OrdersChart";
import PaymentChart from "../components/reports/PaymentChart";
import OrderStatusChart from "../components/reports/OrderStatusChart";

import TopProviders from "../components/reports/TopProviders";
import TopFoods from "../components/reports/TopFoods";

import RecentTransactions from "../components/reports/RecentTransactions";
import SalesTable from "../components/reports/SalesTable";
import ExportButtons from "../components/reports/ExportButtons";

const Reports = () => {

    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("30days");
    const [error, setError] = useState("");

    const [report, setReport] = useState({

        stats: {},

        revenueChart: [],

        ordersChart: [],

        paymentChart: [],

        orderStatus: [],

        topProviders: [],

        topFoods: [],

        recentTransactions: [],

        sales: []

    });

    const fetchReport = async () => {

        try {

            setLoading(true);
            setError("");

            const res = await getDashboardReport(filter);

            setReport({

                stats: res.data.stats || {},

                revenueChart: res.data.revenueChart || [],

                ordersChart: res.data.ordersChart || [],

                paymentChart: res.data.paymentChart || [],

                orderStatus: res.data.orderStatus || [],

                topProviders: res.data.topProviders || [],

                topFoods: res.data.topFoods || [],

                recentTransactions:
                    res.data.recentTransactions || [],

                sales: res.data.sales || []

            });

        } catch (err) {

            console.error(err);

            setError(

                err.response?.data?.message ||

                "Unable to load reports."

            );

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        fetchReport();

    }, [filter]);

    if (loading) {

        return (

            <div className="reports-loading">

                Loading Reports...

            </div>

        );

    }

    if (error) {

        return (

            <div className="reports-error">

                {error}

            </div>

        );

    }

    return (

        <div className="reports-page">

            <ReportHeader

                loading={loading}

                onRefresh={fetchReport}

            />

            <ReportFilterBar

                filter={filter}

                setFilter={setFilter}

            />

            <SummaryCards

                stats={report.stats}

            />

            <div className="reports-grid">

                <RevenueChart

                    data={report.revenueChart}

                />

                <OrdersChart

                    data={report.ordersChart}

                />

            </div>

            <div className="reports-grid">

                <PaymentChart

                    data={report.paymentChart}

                />

                <OrderStatusChart

                    data={report.orderStatus}

                />

            </div>

            <div className="reports-grid">

                <TopProviders

                    providers={report.topProviders}

                />

                <TopFoods

                    foods={report.topFoods}

                />

            </div>

            <RecentTransactions

                transactions={report.recentTransactions}

            />

            <SalesTable

                sales={report.sales}

            />

            <ExportButtons

                report={report}

            />

        </div>

    );

};

export default Reports;